module.exports = __webpack_public_path__ + "img/capability-slider-img_2--mobile.a1bef85.jpg";